import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKeuze = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m24.86 6 2.29 2.28L20 15.43l-7.15-7.15L15.14 6H6v9.14l2.29-2.29 8.48 8.49V34h6.46L23 21.34l8.48-8.49L34 15.14V6z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m21.86 20.479 2.882-2.854-.704-.71-3.178 3.146V35.01h1zM15.847 8.3l1.516-1.516-.707-.708L14.433 8.3l4.053 4.053.707-.707z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKeuze);

export default ForwardRef;
